import { createAxiosInstance, getAuthToken } from '@/dataProvider/axios';
import { env } from '@/config/env';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

// Shared instance for the ide-service proxy (/proxy/ide/*) — previously
// duplicated independently in useFormatCode.ts, useApexLint.ts, and
// useApexAnalysis.ts.
export const ideServiceApi = createAxiosInstance(`${env.API_URL}/proxy/ide`);

export function ideAuthHeaders(orgId?: string | null): Record<string, string> {
  const state = useAuthStoreV1.getState();
  const effectiveOrgId = orgId || state.selectedOrg?.id || null;
  const headers: Record<string, string> = {};
  if (effectiveOrgId) headers['X-Organization-ID'] = effectiveOrgId;
  if (state.user?.id) headers['X-User-ID'] = state.user.id;
  const token = getAuthToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}
